import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {BasketPageService_ApplyCouponLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {ApplyCouponResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {FullSession} from '@aboutyou/user';
import {useCallback} from 'react';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useUpdateBasketSectionsCallback} from './useUpdateBasketSections';

export const useApplyCouponToExistingBasket = () => {
  const targetGroupIdentifier = useTargetGroupIdentifier();

  const updatePageBulkSections = useUpdateBasketSectionsCallback();
  const reductionsState = useReductionsStateRequestParameter();

  const applyCouponCallback = useGrpcRequestMutation(
    BasketPageService_ApplyCouponLazy,
    {
      onSuccess: (data: ApplyCouponResponse) => {
        updatePageBulkSections(data.sections);
      },
    },
  );

  return useCallback(
    (couponPromotionId: string, session: FullSession) => {
      return applyCouponCallback
        .mutateAsync({
          session: session!,
          targetGroup: targetGroupIdentifier,
          couponPromotionId,
          itemKey: null,
          reductionsState,
        })
        .then(data => {
          return {
            basketToken: data.sections.basketToken,
            error: data.type?.error,
            totalPrice: data.sections.totalPriceSection,
          };
        });
    },
    [applyCouponCallback, targetGroupIdentifier, reductionsState],
  );
};
